import {
  takeEvery, put, all
} from 'redux-saga/effects'
import request from '@/helpers/axios'
import { SERVICE_DESK_GET_APPEALS_URL } from '@/constants/apiRoutes'
import { GET_SERVICE_DESK_CARDS } from '@/store/actions/serviceDeskMyCity'
import { successGetInfoCards } from '@/store/actions/serviceDeskMyCity/getInfoCards'
import { getAverageDays } from '@/helpers/serviceDeskHelpers'
import {
  RECEIVED,
  UNREGISTERED,
  WAITING_FOR_EXECUTION,
  DONE,
  TASKS_PERFORMED,
  WAITING_FOR_CONTROL,
  OVERDUE_ON_EXECUTION,
  AVERAGE_LEAD_TIME,
} from '@/constants/serviceDeskMyCity'
import {
  TASK_STATUS,
  TASK,
  EXECUTION_EXPIRED,
  APPEALS_BLOCK,
} from '@/constants/serviceDeskConfig/nameConfig'

const bodyGenerator = (serviceDeskConfig, id, parameters) => {
  return {
    integrationId: id,
    parameters: `IBLOCK_TYPE_ID=lists_socnet&IBLOCK_ID=${serviceDeskConfig[APPEALS_BLOCK].idInfoBlock}&start=0${parameters || ''}`,
    restMethod: '/lists.element.get.json',
  }
}

const cardsInfo = [
  RECEIVED,
  UNREGISTERED,
  WAITING_FOR_EXECUTION,
  DONE,
  TASKS_PERFORMED,
  WAITING_FOR_CONTROL,
  OVERDUE_ON_EXECUTION,
]

function* getServiceDeskCardSaga({ payload }) {
  const { serviceDeskId, serviceDeskConfig } = payload
  try {
    const response = yield all([
      request({
        url: SERVICE_DESK_GET_APPEALS_URL,
        method: 'post',
        body: bodyGenerator(serviceDeskConfig, serviceDeskId),
      }),
      request({
        url: SERVICE_DESK_GET_APPEALS_URL,
        method: 'post',
        body: bodyGenerator(serviceDeskConfig, serviceDeskId, `&FILTER[PROPERTY_${serviceDeskConfig[TASK_STATUS].id}]=&!FILTER[PROPERTY_${serviceDeskConfig[TASK].id}]`),
      }),
      request({
        url: SERVICE_DESK_GET_APPEALS_URL,
        method: 'post',
        body: bodyGenerator(serviceDeskConfig, serviceDeskId, `&FILTER[PROPERTY_${serviceDeskConfig[TASK_STATUS].id}][0]=registered&FILTER[PROPERTY_${serviceDeskConfig[TASK_STATUS].id}][1]=contractorAppointed`),
      }),
      request({
        url: SERVICE_DESK_GET_APPEALS_URL,
        method: 'post',
        body: bodyGenerator(serviceDeskConfig, serviceDeskId, `&FILTER[PROPERTY_${serviceDeskConfig[TASK_STATUS].id}]=completed`),
      }),
      request({
        url: SERVICE_DESK_GET_APPEALS_URL,
        method: 'post',
        body: bodyGenerator(serviceDeskConfig, serviceDeskId, `&FILTER[PROPERTY_${serviceDeskConfig[TASK_STATUS].id}]=inProgress`),
      }),
      request({
        url: SERVICE_DESK_GET_APPEALS_URL,
        method: 'post',
        body: bodyGenerator(serviceDeskConfig, serviceDeskId, `&FILTER[PROPERTY_${serviceDeskConfig[TASK_STATUS].id}]=waitingControl`),
      }),
      request({
        url: SERVICE_DESK_GET_APPEALS_URL,
        method: 'post',
        body: bodyGenerator(serviceDeskConfig, serviceDeskId, `&FILTER[PROPERTY_${serviceDeskConfig[EXECUTION_EXPIRED].id}]=1`),
      }),
    ])
    const averageDays = getAverageDays(response[0].data.result, serviceDeskConfig)
    
    const totalReceived = response[0].data.total || 0
    const totalUnregistered = response[1].data.total || 0
    
    const sortedResponse = [
      {
        type: RECEIVED,
        value: Math.max(0, totalReceived - totalUnregistered),
      },
      ...response.slice(1).map((element, index) => ({
        type: cardsInfo[index + 1],
        value: element.data.total || 0,
      }))
    ]
    
    sortedResponse.push({
      type: AVERAGE_LEAD_TIME,
      value: averageDays,
    })
    
    yield put(successGetInfoCards(sortedResponse))
  } catch (error) {
    console.log('TCL: function*getServiceDeskCardSaga -> error', error)
  }
}

export default function* root() {
  yield takeEvery(GET_SERVICE_DESK_CARDS.REQUEST, getServiceDeskCardSaga)
}
